<template>
  <div v-if="visible">
    <div class="filter-pannel">
      <template v-if="isClassType">
        <div class="options-tabs">
          <div class="options-tab" :class="{ active: !innerValue || !innerValue.length }" @click="innerValue = []">
            全部班级
          </div>
        </div>

        <div v-for="item in options" :key="item.value">
          <div class="option-title">{{ item.label }}</div>
          <div class="options-tabs">
            <div
              class="options-tab"
              :class="{ active: innerValue.includes(child.value) }"
              v-for="child in item.children"
              :key="child.value"
              @click="clickItem(child.value)"
            >
              {{ child.label }}
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div v-if="title" class="option-title">{{ title }}</div>
        <div class="options-tabs">
          <div
            class="options-tab"
            :class="{ active: innerValue === item.value }"
            v-for="item in options"
            :key="item.value"
            @click="clickItem(item.value)"
          >
            {{ item.label }}
          </div>
        </div>
      </template>
      <template v-if="isDateRangeType">
        <div class="option-title">自定义</div>
        <KdDateRangeSelect
          v-model="dateRange"
          class="date-range"
          fromDatePlaceholder="选择开始时间"
          toDatePlaceholder="选择结束时间"
          @change="innerValue = 'custom'"
        />
      </template>
      <div class="actions">
        <div class="reset action-btn" @click="reset">重置</div>
        <div class="confirm action-btn" @click="confirm">确定</div>
      </div>
    </div>
    <div class="filter-pannel-mask" @click="close"></div>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue'
import { KdDateRangeSelect } from 'kuaidong-ui'
import { UIUtil } from 'kuaidong-lib'

const props = defineProps<{
  visible: boolean
  options: { label: string; value: string; children?: { label: string; value: string }[] }[]
  value: string | string[]
  title?: string
  type?: 'date-range' | 'class'
  multiple?: boolean
  startDate?: Date
  endDate?: Date
}>()

const emit = defineEmits<{
  (e: 'input', value: string | string[]): void
  (e: 'reset'): void
  (e: 'confirm', value: string | string[], date?: [Date, Date]): void
  (e: 'update:visible', value: boolean): void
}>()

const innerValue = ref(props.value)

const dateRange = ref([props.startDate, props.endDate])

const isDateRangeType = computed(() => {
  return props.type === 'date-range'
})

const isClassType = computed(() => {
  return props.type === 'class'
})

function clickItem(value: string) {
  if (props.multiple) {
    if (innerValue.value.includes(value)) {
      innerValue.value = (innerValue.value as string[]).filter((item) => item !== value)
    } else {
      innerValue.value = [...(innerValue.value as string[]), value]
    }
  } else {
    innerValue.value = value
  }

  if (isDateRangeType.value) {
    dateRange.value = [undefined, undefined]
  }
}

function close() {
  emit('update:visible', false)
}

function reset() {
  emit('reset')
  close()
}

function confirm() {
  if (isDateRangeType.value && innerValue.value === 'custom') {
    if (dateRange.value.length !== 2 || !dateRange.value[0] || !dateRange.value[1]) {
      UIUtil.showToast('请选择开始和结束时间')
      return
    }
    if (dateRange.value[0] > dateRange.value[1]) {
      UIUtil.showToast('开始时间不能晚于结束时间')
      return
    }
    const afterDate = new Date(dateRange.value[0])
    afterDate.setMonth(afterDate.getMonth() + 6)
    if (afterDate < dateRange.value[1]) {
      UIUtil.showToast('最多只能查看6个月数据')
      return
    }
    emit('input', innerValue.value)
    emit('confirm', innerValue.value, dateRange.value as [Date, Date])
    close()
    return
  }

  emit('input', innerValue.value)
  emit('confirm', innerValue.value)
  close()
}
</script>

<style lang="less" scoped>
.filter-pannel {
  padding-top: 12px;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: white;
  z-index: 9999;

  .option-title {
    color: #4d4d4d;
    font-size: 14px;
    font-weight: 500;
    text-align: left;
    padding-left: 16px;
  }

  .options-tabs {
    padding: 12px 0 12px 16px;
    display: flex;
    flex-wrap: wrap;
  }

  .options-tab {
    box-sizing: border-box;
    height: 32px;
    line-height: 32px;
    min-width: 80px;
    padding: 0 8px;
    background: #f7f8fa;
    color: #81848f;
    border-radius: 4px;
    margin-right: 8px;
    margin-bottom: 8px;
    display: inline-block;

    &:last-child {
      margin-right: 0;
    }

    &.active {
      background: rgba(51, 102, 255, 0.1);
      color: rgba(51, 102, 255, 1);
    }
  }
  .actions {
    display: flex;
    border-top: 1px solid #eee;
    // box-shadow: 0px 1px 0px 0px #eeeeee inset;
  }

  .action-btn {
    width: 100%;
    height: 44px;
    line-height: 44px;
    font-size: 16px;
    font-weight: 500;

    &.cancel {
      color: #4d4d4d;
      background: #fff;
    }

    &.confirm {
      color: #fff;
      background: #3366ff;
    }
  }
  .options-mask {
    position: fixed;
    height: 100vh;
    // top: 100%;
    left: 0;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
  }

  .date-range {
    box-sizing: border-box;
    width: 100%;
    padding: 12px 16px;

    :deep {
      .kd-date-range-select__from-date,
      .kd-date-range-select__to-date {
        background: #f7f8fa;
        height: 32px;
        line-height: 32px;
        width: 160px;
        box-sizing: border-box;
        padding: 0;
      }
    }
  }
}

.filter-pannel-mask {
  position: fixed;
  height: 100vh;
  left: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}
</style>
